import { Pipe, PipeTransform} from '@angular/core'
import { noDieRequiredTemplates } from 'ngrx/status-types'
import { TranslateService } from 'app/i18n'

@Pipe({
    name: 'noDieCheck'
  })
  export class NoDieCheck implements PipeTransform {
    constructor( private translate: TranslateService ) { }

    transform(dieId : string) {
        if(!dieId) return '';
        if(dieId){
            if(noDieRequiredTemplates && noDieRequiredTemplates.indexOf(dieId) >= 0){
                return this.translate.instant('NO_DIE_CUTTING_REQUIRED');
            }else{
                return dieId
            }
        }
    }
  }


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/no-die-check.pipe.ts